import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  filterByEcosystem (event) {
    const ecosystemId = event.target.value
    const url = new URL(window.location)

    if (ecosystemId) {
      url.searchParams.set('ecosystem_id', ecosystemId)
    } else {
      url.searchParams.delete('ecosystem_id')
    }

    window.location.href = url.toString()
  }
}
